// Warm, per-event-type share messaging + channel helpers (WhatsApp / SMS / copy).

export function shareMessage(type, name, url) {
  const msgs = {
    memorial: `We're gathering memories of ${name} for their celebration of life. It would mean so much if you'd share one — it only takes a minute: ${url}`,
    birthday: `We're putting together a surprise video tribute for ${name}'s birthday! Add a quick message from your phone: ${url}`,
    wedding: `We're collecting heartfelt messages for ${name}. Share your love and wishes here: ${url}`,
    anniversary: `We're gathering messages to celebrate ${name}. Share a memory or a wish: ${url}`,
    retirement: `We're putting together a tribute for ${name}'s retirement. Share a memory or a thank-you: ${url}`,
    graduation: `We're collecting messages to celebrate ${name}'s graduation! Add your congratulations: ${url}`,
    farewell: `We're gathering farewell messages for ${name}. Share a memory or a good wish: ${url}`,
    other: `We're gathering messages for ${name}. It would mean a lot if you'd share one: ${url}`,
  };
  return msgs[type] || msgs.other;
}

export function whatsappUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function smsUrl(text) {
  return `sms:?&body=${encodeURIComponent(text)}`;
}

export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch { return false; }
}
